import React, { useState, useEffect } from 'react';
import './scrolltop_component.scss';

const ScrollTop = (props) => {
  
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [arrowBlack, setArrowBlack] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
        if (window.pageYOffset < ((props.nav.current.offsetHeight + props.nav.current.offsetTop) - props.nav.current.lastChild.children[2].clientHeight)){
        setArrowBlack(false)
      } else{
        setArrowBlack(true);
      } 

      if (window.pageYOffset > props.height) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
      
    });
  }, []);
  
  const goToTop = () => {
    window.scrollTo({
      top: props.scroll.current.offsetTop,
      behavior: 'smooth',
    });
  };


  return (
    <div className="top-to-btm">
      {showTopBtn && (
        <button onClick={goToTop} className={'scroll-top' + (arrowBlack ? ' arrow-black' : '')}></button>
      )}
    </div>
  );
};
export default ScrollTop;